export const getCurrentUser = () => (state) => state.currentUser;
